/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from './../../services/modules';
import accountService from './../../services/account';
import warehouseService from '../../services/warehouse';

export default {
  props: {
    mod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new Forms({
        websiteUrl: {
          type: 'text',
          value: '',
        },
        apiKey: {
          type: 'text',
          value: '',
        },
        secretKey: {
          type: 'text',
          value: '',
        },
        language: {
          type: 'select',
          value: 'en',
        },
        warehouseId: {
          type: 'select',
          value: '',
        },
        syncProductGroup: {
          type: 'switch',
          value: '',
        },
        syncSelectedProductsOnly: {
          type: 'switch',
          value: '',
        },
        productAttributes: {
          type: 'checkboxGroup',
          value: [],
        },
      }),
      token: '',
      loading: false,
      generateTokenLoading: false,
      backendUrl: process.env.API_LOCATION,
    };
  },

  computed: {
    ...mapGetters({
      warehouses: 'allWarehouses',
      account: 'account',
    }),
    productAttributesOptions() {
      const attributes = this.$i18n.messages[this.$i18n.locale].static.wooProducts.attributes;
      return Object.entries(attributes).reduce((obj, item) => [...obj, { id: item[0], name: item[1] }], []);
    },
  },

  mounted() {
    this.form.setOptions('language', [{ id: 'en', name: 'English' }, { id: 'nb', name: 'Norwegian' }]);
    this.form.setOptions('productAttributes', this.productAttributesOptions);
    this.show();
  },

  watch: {
    warehouses(warehouses) {
      this.form.setOptions('warehouseId', warehouses.items);
    },
    account(account) {
      if (account && account.isPartner) {
        this.form.hideField('warehouseId');
      }
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    show() {
      Promise.all([
        accountService.wooCredentials(),
        warehouseService.all(),
        accountService.find(),
      ]).then((data) => {
        this.form.websiteUrl = data[0].websiteUrl;
        this.form.apiKey = data[0].apiKey;
        this.form.secretKey = data[0].secretKey;
        this.form.warehouseId = data[0].warehouseId;
        this.form.language = data[0].language;
        this.form.syncProductGroup = data[0].syncProductGroup;
        this.form.syncSelectedProductsOnly = data[0].syncSelectedProductsOnly;
        this.token = data[0].token;
        if (data[0].productAttributes) {
          const productAttributes = [];
          data[0].productAttributes.forEach((m) => {
            const attr = this.productAttributesOptions.find(p => p.id === m);
            productAttributes.push(attr.name);
          });
          this.form.productAttributes = productAttributes;
        }
      });
    },

    store() {
      const productAttributes = [];
      this.form.productAttributes.forEach((m) => {
        const attr = this.productAttributesOptions.find(p => p.name === m);
        productAttributes.push(attr.id);
      });

      const params = {
        module_id: this.mod.id,
        is_woo_api: true,
        website_url: this.form.websiteUrl,
        api_key: this.form.apiKey,
        secret_key: this.form.secretKey,
        warehouse_id: this.form.warehouseId,
        language: this.form.language,
        sync_product_group: this.form.syncProductGroup,
        product_attributes: productAttributes,
        sync_selected_products_only: this.form.syncSelectedProductsOnly,
      };
      modulesService.subscribe(this.mod.id, params).then(() => {
        Promise.all([modulesService.items(), accountService.find()]);
        this.closeModal();
      });
    },

    copyToken() {
      const tokenInput = this.$refs.tokenInput;
      tokenInput.select();
      document.execCommand('copy');
    },

    generateToken() {
      this.generateTokenLoading = true;
      accountService
        .wooGenerateToken()
        .then((result) => {
          this.token = result.token;
          this.generateTokenLoading = false;
        }).catch((err) => {
          this.generateTokenLoading = false;
        });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggleModal(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/wooCredentialsModal/wooCredentialsModal.js